export const environment = {
  production: false,
  url: 'https://vinculacioneslab.lipatinantioquia.com.co',
  urlPagos: 'https://pasarelapagoslab.lipatinantioquia.com.co',
  apiSolicitud: 'https://apim-lipatin-lab-001.azure-api.net/carnetdigital',
  apiDocument: 'https://apim-lipatin-lab-001.azure-api.net/carnetdigital',
  apiRegistration: 'hhttps://apim-lipatin-lab-001.azure-api.net/carnetdigital',
  apiPagos: 'https://apim-lipatin-lab-001.azure-api.net/payments/v2',
  apiAdministration: 'https://apim-lipatin-lab-001.azure-api.net/carnetdigital',
  apiMembers: 'https://apim-lipatin-lab-001.azure-api.net/carnetdigital',
  apiCompetitions: 'https://apim-lipatin-lab-001.azure-api.net/carnetdigital',
  retrayPaymentStatusLimit: 5,
  diclamerDocumentName: 'CONSENTIMIENTO_ESCUELA_2024.docx',
  paymentProductId: 'd61dda2b-92aa-4846-9c1f-2038b91934a1',
  paymentTest: 1,
  renewalModuleIsActive: false,
  memberTransfersIsActive: true,
  recaptcha: {
    siteKey: '6LeXHqMqAAAAAD08_AzmI9SVUor6i6187J_SMxN1',
  },
  apiManagementConfig: {
    carnetdigitalApi: '06a7e8478e204c849f45d1ad754c7063',
    pagosApi: 'e03dc452df104fe5a122ab62ff0e7400',
  },
  msalConfig: {
    auth: {
      clientId: 'b1901e92-2103-4988-a470-00530fb3adb1',
      authority:
        'https://login.microsoftonline.com/4c23a29a-4620-4d97-88e0-0670df67d7ad',
      redirectUri: 'https://vinculacioneslab.lipatinantioquia.com.co',
      redirectLogoutUri: 'https://vinculacioneslab.lipatinantioquia.com.co',
    },
  },
  roles:{
    sidAdmin: 'SID_ADMINISTRATOR',
    sidGestor: 'SID_GESTOR',
    clubAdmin: 'SID_CLUB_ADMIN',
    extAdmin: 'SID_EXT_ADMIN',
    extClubAdmin: 'SID_EXT_CLUB_ADMIN'
  }
};
